export default "__VITE_ASSET__DgTQeqd0__"